import { useState, useEffect, useRef } from 'react';
import { STORAGE_KEYS } from './../utils/AiUtils';

export const useChatStorage = () => {
  const [messages, setMessages] = useState([]);
  const [message, setMessage] = useState('');
  const [attachedFiles, setAttachedFiles] = useState([]);
  const isInitialMount = useRef(true);

  useEffect(() => {
    try {
      const savedMessages = sessionStorage.getItem(STORAGE_KEYS.MESSAGES);
      const savedLastMessage = sessionStorage.getItem(STORAGE_KEYS.LAST_MESSAGE);

      if (savedMessages) {
        setMessages(JSON.parse(savedMessages));
      }

      if (savedLastMessage) {
        setMessage(savedLastMessage);
      }
    } catch (e) {
    }
  }, []);

  useEffect(() => {
    if (isInitialMount.current) {
      isInitialMount.current = false;
      return;
    }

    try {
      if (messages.length > 0) {
        sessionStorage.setItem(STORAGE_KEYS.MESSAGES, JSON.stringify(messages));
      } else {
        sessionStorage.removeItem(STORAGE_KEYS.MESSAGES);
      }
    } catch (e) {
    }
  }, [messages]);

  useEffect(() => {
    try {
      sessionStorage.setItem(STORAGE_KEYS.LAST_MESSAGE, message);
    } catch (e) {
    }
  }, [message]);

  useEffect(() => {
    try {
      const fileMetadata = attachedFiles.map(file => ({
        id: file.id,
        name: file.name,
        size: file.size,
        type: file.type
      }));
      sessionStorage.setItem(STORAGE_KEYS.ATTACHED_FILES, JSON.stringify(fileMetadata));
    } catch (e) {
    }
  }, [attachedFiles]);

  const clearAllStorage = () => {
    try {
      sessionStorage.removeItem(STORAGE_KEYS.MESSAGES);
      sessionStorage.removeItem(STORAGE_KEYS.LAST_MESSAGE);
      sessionStorage.removeItem(STORAGE_KEYS.ATTACHED_FILES);

      sessionStorage.setItem(STORAGE_KEYS.LATEST_SESSION_DATA_ID, '');

      if (window.resetSessionDataId) {
        window.resetSessionDataId();
      }

      return true;
    } catch (e) {
    }

    return false;
  };

  return {
    messages,
    setMessages,
    message,
    setMessage,
    attachedFiles,
    setAttachedFiles,
    clearAllStorage
  };
};